// @owners { team: patients }
import { BREAKPOINTS } from '@alto/design-library-tokens';
import { useCallback, useSyncExternalStore } from 'react';

// use CSS media-queries for resizing, don't re-render within javascript
export const useDeprecatedMediaQuery = (breakpoint: keyof typeof BREAKPOINTS) => {
  const query = `(min-width: ${BREAKPOINTS[breakpoint]}px)`;

  const subscribe = useCallback((onStoreChange: () => void) => {
    window.addEventListener('resize', onStoreChange);
    return () => {
      window.removeEventListener('resize', onStoreChange);
    };
  }, []);

  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);

  return useSyncExternalStore(subscribe, getSnapshot);
};
